"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toaster = Toaster;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _lucideReact = require("lucide-react");
var _useToast2 = require("@/hooks/use-toast");
var _toast = require("./toast");
var _excluded = ["description", "id", "title", "variant"];
/** Global shadcn toast renderer. */
function Toaster() {
  var _useToast = (0, _useToast2.useToast)(),
    toasts = _useToast.toasts;
  return /*#__PURE__*/_react["default"].createElement(_toast.ToastProvider, {
    duration: 5000,
    swipeDirection: "up",
    "data-sentry-element": "ToastProvider",
    "data-sentry-component": "Toaster",
    "data-sentry-source-file": "toaster.tsx"
  }, toasts.map(function (_ref) {
    var description = _ref.description,
      id = _ref.id,
      title = _ref.title,
      variant = _ref.variant,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_toast.Toast, (0, _extends2["default"])({
      key: id,
      variant: variant
    }, props), variant === 'success' && /*#__PURE__*/_react["default"].createElement(_lucideReact.CheckCircle2, {
      "aria-hidden": "true",
      className: "h-8 w-8 shrink-0 fill-success-regular text-white"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "min-w-0 flex-1"
    }, title && /*#__PURE__*/_react["default"].createElement(_toast.ToastTitle, null, title), description && /*#__PURE__*/_react["default"].createElement(_toast.ToastDescription, null, description)), /*#__PURE__*/_react["default"].createElement(_toast.ToastClose, null));
  }), /*#__PURE__*/_react["default"].createElement(_toast.ToastViewport, {
    "data-sentry-element": "ToastViewport",
    "data-sentry-source-file": "toaster.tsx"
  }));
}